export default {
    showBadge: false,
    activeLeadFormTask: '',
    activeAppointmentTypeTask: '',
};
